import hygraphClient from './hygraph';
import { GET_ALL_BLOCKCHAINS, GET_LIVE_BLOCKCHAINS, GET_BLOCKCHAIN_BY_NAME, GET_SOCIAL_LINKS } from './blockchainQueries';
import type { HygraphBlockchain, BlockchainsResponse, HygraphSocialLink, SocialLinksResponse } from '../types';

export class BlockchainService {
  static async getAllBlockchains(): Promise<HygraphBlockchain[]> {
    try {
      const data: BlockchainsResponse = await hygraphClient.request(GET_ALL_BLOCKCHAINS);
      return data.blockchains;
    } catch (error) {
      console.error('Error fetching blockchains from Hygraph:', error);
      throw error;
    }
  }

  static async getLiveBlockchains(): Promise<HygraphBlockchain[]> {
    try {
      const data: BlockchainsResponse = await hygraphClient.request(GET_LIVE_BLOCKCHAINS);
      return data.blockchains;
    } catch (error) {
      console.error('Error fetching live blockchains from Hygraph:', error);
      throw error;
    }
  }

  static async getBlockchainByName(name: string): Promise<HygraphBlockchain | null> {
    try {
      const data: BlockchainsResponse = await hygraphClient.request(GET_BLOCKCHAIN_BY_NAME, { name });
      return data.blockchains.length > 0 ? data.blockchains[0] : null;
    } catch (error) {
      console.error(`Error fetching blockchain ${name} from Hygraph:`, error);
      throw error;
    }
  }

  static async getSocialLinks(): Promise<HygraphSocialLink[]> {
    try {
      const data: SocialLinksResponse = await hygraphClient.request(GET_SOCIAL_LINKS);
      return data.socialLinks;
    } catch (error) {
      console.error('Error fetching social links from Hygraph:', error);
      throw error;
    }
  }

}